import {isMobile, getScript} from "../modules/general";

document.addEventListener('DOMContentLoaded', () => {
    const wrapperMap = document.querySelector('#map');

    if (!wrapperMap) return;

    const initializeMap = () => {
        // маркер отеля
        if (typeof hotelMarker == "object") {
            const placemark = hotelMarker.location,
                zoom = 15,
                behaviors = ['drag', 'dblClickZoom', 'multiTouch', 'zoom'],
                map = new ymaps.Map('map', {
                    behaviors: behaviors,
                    center: placemark,
                    controls: [],
                    zoom: zoom
                });

            map.controls.add('zoomControl', {
                size: "small",
                position: {
                    top: 45,
                    right: 15
                }
            });

            if (isMobile.any()) {
                map.behaviors.disable('drag');
            }

            const sizeValue = (window.innerWidth < 360) ? [26, 30] : ((window.innerWidth < 1326) ? [34, 40] : [42, 50]);
            const offsetValue = (window.innerWidth < 360) ? [-13, -30] : ((window.innerWidth < 1326) ? [-17, -40] : [-21, -50]);

            const markerDefault = {
                iconLayout: ymaps.templateLayoutFactory.createClass(
                    '<div class="map__marker icon icon-marker"></div>'
                ),
                iconSize: sizeValue,
                iconOffset: offsetValue,
                iconShape: {
                    type: 'Rectangle',
                    coordinates: [[0, 0], sizeValue]
                }
            };

            if (wrapperMap.classList.contains('about-map')) {
              const setMarkers = () => {
                MARKERS.forEach(marker => {
                  map.geoObjects.add(new ymaps.Placemark(marker.coords, {
                    balloonContent: marker.title
                  }, {
                    iconLayout: ymaps.templateLayoutFactory.createClass(
                      `<div class="map__marker map__marker--about icon icon-marker-2">
                            <span class="icon ${marker.iconCssClass}"></span>
                        </div>`
                    ),
                    iconSize: [50, 50],
                    iconOffset: [-25, -50],
                    iconShape: {
                      type: 'Rectangle',
                      coordinates: [[0, 0], [50, 50]],
                    }
                  }))
                });
              };

              setMarkers();
            }
            else {
              map.geoObjects.add(new ymaps.Placemark(placemark, {
                hintContent: hotelMarker.title
              }, markerDefault));
            }
        }
    }

    const loadMap = () => {
        const parameters = (!hotelMarker.yaMapApiKey || /^\s*$/.test(hotelMarker.yaMapApiKey)) ? 'lang=' + hotelMarker.locale : 'apikey=' + hotelMarker.yaMapApiKey + '&lang=' + hotelMarker.locale;
        getScript('//api-maps.yandex.ru/2.1/?' + parameters)
            .then(() => {
                ymaps.ready(() => {
                    initializeMap();
                });
            })
            .catch(() => {
                console.error('Could not load script')
            })
    };

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                observer.unobserve(entry.target);
                loadMap();
            }
        });
    };

    if (!('IntersectionObserver' in window)) {
        loadMap();
    } else {
        const config = {
            rootMargin: '500px 0px',
            threshold: 0
        };

        const observer = new IntersectionObserver(callback, config);
        observer.observe(wrapperMap);
    }
});
